import React from "react";

const DeleteIcon = (props) => {
  const { slectedIcon } = props;
  return slectedIcon ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
    >
      <path
        d="M2.89932 3.8V2.4C2.89932 2.0287 3.04682 1.6726 3.30937 1.41005C3.57192 1.1475 3.92801 1 4.29932 1H7.09932C7.47062 1 7.82672 1.1475 8.08927 1.41005C8.35182 1.6726 8.49932 2.0287 8.49932 2.4V3.8M10.5993 3.8V13.6C10.5993 13.9713 10.4518 14.3274 10.1893 14.5899C9.92672 14.8525 9.57062 15 9.19932 15H2.19932C1.82801 15 1.47192 14.8525 1.20937 14.5899C0.946816 14.3274 0.799316 13.9713 0.799316 13.6V3.8H10.5993Z"
        stroke="#172B4D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 4.5h18M6 4.5v-2a2 2 
        0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-14h14z"
        stroke="#5C5F62"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DeleteIcon;
